import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {GridTable, ResultsPager} from "../../../../Components/Grid";
import React from "react";
import {LoanHistoryRow} from "./LoanHistoryRow";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface LoanHistoryViewProps {
    handleSetLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    loanHistories: Record<string, any>[];
    loanHistorySearchCriteria: Record<string, any>;
    redirect?: (route: string) => void;
    totalRecords: number;
}

export const LoanHistoryView = ({
                                    handleSetLoanHistorySearchCriteria,
                                    loanHistories,
                                    loanHistorySearchCriteria,
                                    totalRecords
                                }: LoanHistoryViewProps) => {

    const isLoanHistoriesEmpty = isArrayNullOrEmpty(loanHistories);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        let criteria = {...loanHistorySearchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        handleSetLoanHistorySearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...loanHistorySearchCriteria};
        criteria.First();
        handleSetLoanHistorySearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...loanHistorySearchCriteria};
        criteria.Previous();
        handleSetLoanHistorySearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...loanHistorySearchCriteria};
        criteria.Next();
        handleSetLoanHistorySearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...loanHistorySearchCriteria};
        criteria.Last(totalRecords);
        handleSetLoanHistorySearchCriteria(criteria);
    };
    const pager = (isSecondaryPager: boolean) =>
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={loanHistorySearchCriteria.recordsPerPage}
            currentPage={loanHistorySearchCriteria.page}
            disabled={false}
        />;

    return <>
        {pager(false)}
        <GridTable className="searchResults">
            <thead>
            <tr>

                <th onClick={handleOrderClick} className="is-clickable" data-id="barCode">Access Number</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="title">Catalog Title</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="patronName">Patron</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="studentName">Student</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocationName">Shipping Location
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateCheckedOut">Date Checked Out</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateReturned">Date Returned</th>
                {
                    isAdmin() &&
                    <th onClick={handleOrderClick} className="is-clickable" data-id="dateOrderSentToVendor">Date Order
                        Sent to Vendor</th>
                }
            </tr>
            </thead>
            <tbody>
            {
                !isLoanHistoriesEmpty && loanHistories &&
                loanHistories.map((loanHistory: Record<string, any>) => {
                    return <LoanHistoryRow
                        key={loanHistory.id}
                        loanHistory={loanHistory}
                    />;
                })
            }
            {
                isLoanHistoriesEmpty &&
                <tr data-testid={`no-order-row`}>
                    <td colSpan={isAdmin() ? 8 : 7} className={`text-center`}>No results found.</td>
                </tr>
            }
            </tbody>
        </GridTable>
        {pager(true)}
    </>;
};
